(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

    // AddToCart button product card
    function handleClick(e){
      var btn = e.target.closest('.product-buy-buttons--primary');
      if (!btn) return;

      // if it's a smart payment secondary button, don't intercept
      if (btn.getAttribute('data-item') === 'secondary-button') return;

      var root = btn.closest('product-buy-buttons-root') || btn.closest('.product-buy-buttons--root');
      if (!root) return;

      e.preventDefault();

      if (btn.disabled) return;

      var select = root.querySelector('.product-buy-buttons--select');
      var variantId = select ? select.value : null;
      if (!variantId) return;

      //btn.setAttribute('aria-busy','true');
      //btn.disabled = true;

      var textEl = btn.querySelector('.product-buy-buttons--cta-text');
      textEl.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(response){
        if (!response.ok) throw response;
        return response.json();
      })
      .then(function(data){
        try { window.dispatchEvent(new CustomEvent('cart:ajaxAdd', { detail: data })); } catch(e){}

        var textEl = btn.querySelector('.product-buy-buttons--cta-text');
        var originalText = btn.getAttribute('data-text') || (textEl ? textEl.textContent : 'Added');
        if (textEl) textEl.textContent = 'Added';
        setTimeout(function(){ if (textEl) textEl.textContent = originalText; }, 1400);
      })
      .catch(function(err){
        if (err && typeof err.json === 'function') {
          err.json().then(function(j){ console.error('Add to cart error', j); });
        } else {
          console.error(err);
        }
      })
      .finally(function(){
        //btn.setAttribute('aria-busy','false');
        //btn.disabled = false;
      });
    }

    document.addEventListener('click', handleClick, { capture: false });

  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-bundle-builder-3"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // --- Bundle Builder State and Logic ---
    let step = 1; // 1: shades, 2: add-ons, 3: accessory
    let pickedShades = [];
    let pickedAddon = null;
    let pickedAccessory = null;
    const bundle = [];
  
    // DOM
    const shadesSection = document.getElementById('shades-section');
    const addonsSection = document.getElementById('addons-section');
    const freegiftSection = document.getElementById('freegift-section');
    const bundleItems = document.getElementById('bundle-items');
    const addBundleToCartBtn = document.getElementById('add-bundle-to-cart');
  
    // Helper: Get product data from DOM
    function getProductData(card) {
      const variantId = card.dataset.variantId || card.dataset.productId;
      const productId = card.dataset.productId;
      const title = card.querySelector('.product-title').textContent.trim();
      const price = parseFloat(card.querySelector('.product-price').textContent.replace(/[^0-9.]/g, ''));
      const image = card.querySelector('[data-main-image]').src;
      return { id: variantId, variant_id: variantId, product_id: productId, title, price, image };
    }
  
    // UI update
    function updateStepUI() {
      shadesSection.style.display = step === 1 ? '' : 'none';
      addonsSection.style.display = step === 2 ? '' : 'none';
      freegiftSection.style.display = step === 3 ? '' : 'none';
      updateBundleItems();
      addBundleToCartBtn.disabled = !(pickedShades.length === 3 && pickedAddon && pickedAccessory);
      addBundleToCartBtn.textContent = (pickedShades.length === 3 && pickedAddon && pickedAccessory) ? 'Add Bundle to Cart' : 'Complete Bundle';
    }
  
    // Bundle items UI
    function updateBundleItems() {
      bundle.length = 0;
      pickedShades.forEach(s => bundle.push(s));
      if (pickedAddon) bundle.push(pickedAddon);
      if (pickedAccessory) bundle.push(pickedAccessory);
      bundleItems.innerHTML = '';
      const slotLabels = ['Shade', 'Shade', 'Shade', 'Accessory', 'Gift'];
      
      // Create all 5 boxes directly in the grid
      for (let i = 0; i < 5; i++) {
        if (i < bundle.length) {
          const item = bundle[i];
          bundleItems.innerHTML += `<div class="bundle-item-cs3"><img src="${item.image}" alt="${item.title}" style="max-width:100px;" loading="lazy" decoding="async"><div>${item.title}</div><button class="remove-from-bundle" data-index="${i}" type="button">Remove</button></div>`;
        } else {
          bundleItems.innerHTML += `<div class="bundle-item-cs3 bundle-item-cs3-scaffold"><span style="color:#aaa;">${slotLabels[i]}</span></div>`;
        }
      }
      bundleItems.querySelectorAll('.remove-from-bundle').forEach(btn => {
        btn.onclick = function() {
          const idx = parseInt(this.dataset.index);
          if (idx < 3) {
            pickedShades.splice(idx, 1);
            pickedAddon = null;
            pickedAccessory = null;
            step = 1;
          } else if (idx === 3) {
            pickedAddon = null;
            pickedAccessory = null;
            if (step === 3) {
              step = 2;
            }
          } else if (idx === 4) {
            pickedAccessory = null;
          }
          updateStepUI();
        };
      });
      // --- Bundle total calculation ---
      const paidItems = bundle.filter((item, idx) => !(idx === 4 && item && item.price === 0));
      const originalTotal = paidItems.reduce((sum, item) => sum + (item.price || 0), 0);
      const discountedTotal = Math.round(originalTotal * 0.75 * 100) / 100;
      const savings = originalTotal - discountedTotal;
      document.getElementById('bundle-discounted-total').textContent = `$${discountedTotal.toFixed(2)}`;
      const originalTotalEl = document.getElementById('bundle-original-total');
      if (originalTotal > 0) {
        originalTotalEl.textContent = `$${originalTotal.toFixed(2)}`;
        originalTotalEl.style.display = 'inline';
        document.getElementById('bundle-savings').textContent = `You saved $${savings.toFixed(2)}`;
      } else {
        originalTotalEl.style.display = 'none';
        document.getElementById('bundle-savings').textContent = 'You saved $0.00';
      }
      updateMiniDock();
    }
  
    // Event delegation for all Add to Bundle buttons
    document.addEventListener('click', function(e) {
      if (e.target.classList.contains('pick-shade-btn')) {
        const card = e.target.closest('.product-card');
        const data = getProductData(card);
        if (pickedShades.length < 3 && !pickedShades.find(s => s.id === data.id)) {
          pickedShades.push(data);
          if (pickedShades.length === 3) {
            step = 2;
            updateStepUI();
            setTimeout(function() {
              if (window.innerWidth <= 767) {
                var addonsHeading = document.querySelector('#addons-section h3');
                if (addonsHeading) {
                  addonsHeading.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  setTimeout(function() {
                    window.scrollBy({ top: -60, left: 0, behavior: 'instant' });
                  }, 400);
                }
              } else if (window.innerWidth > 767) {
                var addonsHeading = document.querySelector('#addons-section h3');
                if (addonsHeading && addonsHeading.offsetParent !== null) {
                  addonsHeading.scrollIntoView({ behavior: 'smooth', block: 'start' });
                } else {
                  var banner = document.querySelector('.bundle-explanation-banner');
                  if (banner) {
                    banner.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }
              }
            }, 50);
          } else {
            updateStepUI();
          }
        }
      } else if (e.target.classList.contains('pick-addon-btn')) {
        const card = e.target.closest('.product-card');
        const data = getProductData(card);
        pickedAddon = data;
        step = 3;
        updateStepUI();
        setTimeout(function() {
          if (window.innerWidth <= 767) {
            var accessoryHeading = document.querySelector('#freegift-section h3');
            if (accessoryHeading) {
              accessoryHeading.scrollIntoView({ behavior: 'smooth', block: 'start' });
              setTimeout(function() {
                window.scrollBy({ top: -60, left: 0, behavior: 'instant' });
              }, 400);
            }
          }
        }, 50);
      } else if (e.target.classList.contains('pick-accessory-btn')) {
        const card = e.target.closest('.product-card');
        const data = getProductData(card);
        data.price = 0; // Make the accessory free
        pickedAccessory = data;
        updateStepUI();
      }
    });
  
    // Add to cart
    addBundleToCartBtn.onclick = function() {
      if (pickedShades.length < 3 || !pickedAddon || !pickedAccessory) {
        return;
      }
      const items = [];
      pickedShades.forEach(item => {
        const variantId = item.id || item.variant_id;
        items.push({
          id: variantId,
          quantity: 1,
          properties: { '_bundleCS': 'true' }
        });
      });
      const addonVariantId = pickedAddon.id || pickedAddon.variant_id;
      items.push({
        id: addonVariantId,
        quantity: 1,
        properties: { '_bundleCS': 'true' }
      });
      if (pickedAccessory && (pickedAccessory.id || pickedAccessory.variant_id)) {
        const accessoryVariantId = pickedAccessory.id || pickedAccessory.variant_id;
        items.push({
          id: accessoryVariantId,
          quantity: 1,
          properties: { '_free_accessory': 'true', '_bundleCS': 'true' }
        });
      }
      addBundleToCartBtn.textContent = 'Adding...';
      addBundleToCartBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })
        .then(r => {
          if (!r.ok) throw new Error(`HTTP error! Status: ${r.status}`);
          return r.json();
        })
        .then(response => {
          pickedShades = [];
          pickedAddon = null;
          pickedAccessory = null;
          step = 1;
          updateStepUI();
        })
        .catch(e => {
          alert('There was an issue adding your bundle to the cart. Please try again.');
        })
        .finally(() => {
          addBundleToCartBtn.textContent = 'Complete Bundle';
          addBundleToCartBtn.disabled = false;
        });
    };
  
    // Initial UI
    updateStepUI();
  
    // --- Mini Dock Show/Hide Logic ---
    var miniDock = document.getElementById('mini-bundle-dock');
    var bundleSection = document.querySelector('.bundle-section');
    function updateMiniDock() {
      if (!miniDock || !bundleSection) return;
      if (window.innerWidth > 767) {
        miniDock.style.display = 'none';
        return;
      }
      var rect = bundleSection.getBoundingClientRect();
      var isTopOutOfView = rect.top < 0;
      if (isTopOutOfView) {
        miniDock.style.display = 'flex';
      } else {
        miniDock.style.display = 'none';
      }
      // Update mini dock content
      if (miniPicks) {
        miniPicks.innerHTML = '';
        bundle.forEach(item => {
          miniPicks.innerHTML += `<img src="${item.image}" alt="${item.title}" loading="lazy" decoding="async">`;
        });
      }
      if (miniCount) {
        miniCount.textContent = bundle.length;
      }
      // Update price and savings
      const paidItems = bundle.filter((item, idx) => !(idx === 4 && item && item.price === 0));
      const originalTotal = paidItems.reduce((sum, item) => sum + (item.price || 0), 0);
      const discountedTotal = Math.round(originalTotal * 0.75 * 100) / 100;
      const savings = originalTotal - discountedTotal;
      const priceEl = miniDock.querySelector('.mini-bundle-price');
      const savingsEl = miniDock.querySelector('.mini-bundle-savings');
      if (priceEl) priceEl.textContent = `$${discountedTotal.toFixed(2)}`;
      if (savingsEl) savingsEl.textContent = `You saved $${savings.toFixed(2)}`;
    }
  
    // --- Mini Dock Show/Hide Logic ---
    var miniPicks = miniDock ? miniDock.querySelector('.mini-bundle-picks') : null;
    var miniCount = miniDock ? miniDock.querySelector('.mini-bundle-count') : null;
    function updateMiniDock() {
      if (!miniDock || !bundleSection) return;
      if (window.innerWidth > 767) {
        miniDock.style.display = 'none';
        return;
      }
      var rect = bundleSection.getBoundingClientRect();
      var isTopOutOfView = rect.top < 0;
      if (isTopOutOfView) {
        miniDock.style.display = 'flex';
      } else {
        miniDock.style.display = 'none';
      }
      // Update mini dock content
      if (miniPicks) {
        miniPicks.innerHTML = '';
        bundle.forEach(item => {
          miniPicks.innerHTML += `<img src="${item.image}" alt="${item.title}" loading="lazy" decoding="async">`;
        });
      }
      if (miniCount) {
        miniCount.textContent = bundle.length;
      }
      // Update price and savings
      const paidItems = bundle.filter((item, idx) => !(idx === 4 && item && item.price === 0));
      const originalTotal = paidItems.reduce((sum, item) => sum + (item.price || 0), 0);
      const discountedTotal = Math.round(originalTotal * 0.75 * 100) / 100;
      const savings = originalTotal - discountedTotal;
      const priceEl = miniDock.querySelector('.mini-bundle-price');
      const savingsEl = miniDock.querySelector('.mini-bundle-savings');
      if (priceEl) priceEl.textContent = `$${discountedTotal.toFixed(2)}`;
      if (savingsEl) savingsEl.textContent = `You saved $${savings.toFixed(2)}`;
    }
  
    // Initial UI
    updateStepUI();
  
    // --- Mini Dock Show/Hide Logic ---
    var miniDock = document.getElementById('mini-bundle-dock');
    var bundleSection = document.querySelector('.bundle-section');
    function updateMiniDock() {
      if (!miniDock || !bundleSection) return;
      if (window.innerWidth > 767) {
        miniDock.style.display = 'none';
        return;
      }
      var rect = bundleSection.getBoundingClientRect();
      var isTopOutOfView = rect.top < 0;
      if (isTopOutOfView) {
        miniDock.style.display = 'flex';
      } else {
        miniDock.style.display = 'none';
      }
      // Update mini dock content
      if (miniPicks) {
        miniPicks.innerHTML = '';
        bundle.forEach(item => {
          miniPicks.innerHTML += `<img src="${item.image}" alt="${item.title}" loading="lazy" decoding="async">`;
        });
      }
      if (miniCount) {
        miniCount.textContent = bundle.length;
      }
      // Update price and savings
      const paidItems = bundle.filter((item, idx) => !(idx === 4 && item && item.price === 0));
      const originalTotal = paidItems.reduce((sum, item) => sum + (item.price || 0), 0);
      const discountedTotal = Math.round(originalTotal * 0.75 * 100) / 100;
      const savings = originalTotal - discountedTotal;
      const priceEl = miniDock.querySelector('.mini-bundle-price');
      const savingsEl = miniDock.querySelector('.mini-bundle-savings');
      if (priceEl) priceEl.textContent = `$${discountedTotal.toFixed(2)}`;
      if (savingsEl) savingsEl.textContent = `You saved $${savings.toFixed(2)}`;
    }
  
    // Initial UI
    updateStepUI();
  
    // Make Review Bundle button scroll to Add Bundle to Cart button
    var miniReviewBtn = miniDock ? miniDock.querySelector('.mini-bundle-review-btn') : null;
    if (miniReviewBtn && addBundleToCartBtn) {
      miniReviewBtn.addEventListener('click', function() {
        addBundleToCartBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-bundle-builder"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // --- Bundle Builder State and Logic ---
  let step = 1; // 1: shades, 2: add-ons, 3: accessory
  let pickedShades = [];
  let pickedAddon = null;
  let pickedAccessory = null;
  const bundle = [];

  // DOM
  const shadesSection = document.getElementById('shades-section');
  const addonsSection = document.getElementById('addons-section');
  const freegiftSection = document.getElementById('freegift-section');
  const bundleItems = document.getElementById('bundle-items');
  const addBundleToCartBtn = document.getElementById('add-bundle-to-cart');

  // Helper: Get product data from DOM
  function getProductData(card) {
    const variantId = card.dataset.variantId || card.dataset.productId;
    const productId = card.dataset.productId;
    const title = card.querySelector('.product-title').textContent.trim();
    const price = parseFloat(card.querySelector('.product-price').textContent.replace(/[^0-9.]/g, ''));
    const image = card.querySelector('[data-main-image]').src;
    return { id: variantId, variant_id: variantId, product_id: productId, title, price, image };
  }

  // UI update
  function updateStepUI() {
    shadesSection.style.display = step === 1 ? '' : 'none';
    addonsSection.style.display = step === 2 ? '' : 'none';
    freegiftSection.style.display = step === 3 ? '' : 'none';
    updateBundleItems();
    addBundleToCartBtn.disabled = !(pickedShades.length === 2 && pickedAddon && pickedAccessory);
    addBundleToCartBtn.textContent = (pickedShades.length === 2 && pickedAddon && pickedAccessory) ? 'Add Bundle to Cart' : 'Complete Bundle';
  }

  // Bundle items UI
  function updateBundleItems() {
    bundle.length = 0;
    pickedShades.forEach(s => bundle.push(s));
    if (pickedAddon) bundle.push(pickedAddon);
    if (pickedAccessory) bundle.push(pickedAccessory);
    bundleItems.innerHTML = '';
    const slotLabels = ['Select', 'Select', 'Select', 'Gift'];
    bundle.forEach((item, idx) => {
      bundleItems.innerHTML += `<div class="bundle-item"><img src="${item.image}" alt="${item.title}" style="max-width:100px;" loading="lazy" decoding="async"><div>${item.title}</div><button class="remove-from-bundle" data-index="${idx}" type="button">Remove</button></div>`;
    });
    for (let i = bundle.length; i < 4; i++) {
      bundleItems.innerHTML += `<div class="bundle-item"><span style="color:#aaa;">${slotLabels[i]}</span></div>`;
    }
    bundleItems.querySelectorAll('.remove-from-bundle').forEach(btn => {
      btn.onclick = function() {
        const idx = parseInt(this.dataset.index);
        if (idx < 2) {
          pickedShades.splice(idx, 1);
          pickedAddon = null;
          pickedAccessory = null;
          step = 1;
        } else if (idx === 2) {
          pickedAddon = null;
          pickedAccessory = null;
          if (step === 3) {
            step = 2;
          }
        } else if (idx === 3) {
          pickedAccessory = null;
        }
        updateStepUI();
      };
    });
    // --- Bundle total calculation ---
    const paidItems = bundle.filter((item, idx) => !(idx === 3 && item && item.price === 0));
    const originalTotal = paidItems.reduce((sum, item) => sum + (item.price || 0), 0);
    const discountedTotal = Math.round(originalTotal * 0.75 * 100) / 100;
    const savings = originalTotal - discountedTotal;
    document.getElementById('bundle-discounted-total').textContent = `$${discountedTotal.toFixed(2)}`;
    const originalTotalEl = document.getElementById('bundle-original-total');
    if (originalTotal > 0) {
      originalTotalEl.textContent = `$${originalTotal.toFixed(2)}`;
      originalTotalEl.style.display = 'inline';
      document.getElementById('bundle-savings').textContent = `You saved $${savings.toFixed(2)}`;
    } else {
      originalTotalEl.style.display = 'none';
      document.getElementById('bundle-savings').textContent = 'You saved $0.00';
    }
    updateMiniDock();
  }

  // Event delegation for all Add to Bundle buttons
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('pick-shade-btn')) {
      const card = e.target.closest('.product-card');
      const data = getProductData(card);
      if (pickedShades.length < 2 && !pickedShades.find(s => s.id === data.id)) {
        pickedShades.push(data);
        if (pickedShades.length === 2) {
          step = 2;
          updateStepUI();
          setTimeout(function() {
            if (window.innerWidth <= 767) {
              var addonsHeading = document.querySelector('#addons-section h3');
              if (addonsHeading) {
                addonsHeading.scrollIntoView({ behavior: 'smooth', block: 'start' });
                setTimeout(function() {
                  window.scrollBy({ top: -60, left: 0, behavior: 'instant' });
                }, 400);
              }
            } else if (window.innerWidth > 767) {
              var addonsHeading = document.querySelector('#addons-section h3');
              if (addonsHeading && addonsHeading.offsetParent !== null) {
                addonsHeading.scrollIntoView({ behavior: 'smooth', block: 'start' });
              } else {
                var banner = document.querySelector('.bundle-explanation-banner');
                if (banner) {
                  banner.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
              }
            }
          }, 50);
        } else {
          updateStepUI();
        }
      }
    } else if (e.target.classList.contains('pick-addon-btn')) {
      const card = e.target.closest('.product-card');
      const data = getProductData(card);
      pickedAddon = data;
      step = 3;
      updateStepUI();
      setTimeout(function() {
        if (window.innerWidth <= 767) {
          var accessoryHeading = document.querySelector('#freegift-section h3');
          if (accessoryHeading) {
            accessoryHeading.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setTimeout(function() {
              window.scrollBy({ top: -60, left: 0, behavior: 'instant' });
            }, 400);
          }
        }
      }, 50);
    } else if (e.target.classList.contains('pick-accessory-btn')) {
      const card = e.target.closest('.product-card');
      const data = getProductData(card);
      data.price = 0; // Make the accessory free
      pickedAccessory = data;
      updateStepUI();
    }
  });

  // Add to cart
  addBundleToCartBtn.onclick = function() {
    if (pickedShades.length < 2 || !pickedAddon || !pickedAccessory) {
      return;
    }
    const items = [];
    pickedShades.forEach(item => {
      const variantId = item.id || item.variant_id;
      items.push({
        id: variantId,
        quantity: 1,
        properties: { '_bundleCS': 'true' }
      });
    });
    const addonVariantId = pickedAddon.id || pickedAddon.variant_id;
    items.push({
      id: addonVariantId,
      quantity: 1,
      properties: { '_bundleCS': 'true' }
    });
    if (pickedAccessory && (pickedAccessory.id || pickedAccessory.variant_id)) {
      const accessoryVariantId = pickedAccessory.id || pickedAccessory.variant_id;
      items.push({
        id: accessoryVariantId,
        quantity: 1,
        properties: { '_free_accessory': 'true', '_bundleCS': 'true' }
      });
    }
    addBundleToCartBtn.textContent = 'Adding...';
    addBundleToCartBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    })
      .then(r => {
        if (!r.ok) throw new Error(`HTTP error! Status: ${r.status}`);
        return r.json();
      })
      .then(response => {
        pickedShades = [];
        pickedAddon = null;
        pickedAccessory = null;
        step = 1;
        updateStepUI();
      })
      .catch(e => {
        alert('There was an issue adding your bundle to the cart. Please try again.');
      })
      .finally(() => {
        addBundleToCartBtn.textContent = 'Complete Bundle';
        addBundleToCartBtn.disabled = false;
      });
  };

  // Initial UI
  updateStepUI();

  // --- Mini Dock Show/Hide Logic ---
  var miniDock = document.getElementById('mini-bundle-dock');
  var bundleSection = document.querySelector('.bundle-section');
  function updateMiniDock() {
    if (!miniDock || !bundleSection) return;
    if (window.innerWidth > 767) {
      miniDock.style.display = 'none';
      return;
    }
    var rect = bundleSection.getBoundingClientRect();
    var isTopOutOfView = rect.top < 0;
    if (isTopOutOfView) {
      miniDock.style.display = 'flex';
    } else {
      miniDock.style.display = 'none';
    }
    // Update mini dock content
    if (miniPicks) {
      miniPicks.innerHTML = '';
      bundle.forEach(item => {
        miniPicks.innerHTML += `<img src="${item.image}" alt="${item.title}" loading="lazy" decoding="async">`;
      });
    }
    if (miniCount) {
      miniCount.textContent = bundle.length;
    }
    // Update price and savings
    const paidItems = bundle.filter((item, idx) => !(idx === 3 && item && item.price === 0));
    const originalTotal = paidItems.reduce((sum, item) => sum + (item.price || 0), 0);
    const discountedTotal = Math.round(originalTotal * 0.75 * 100) / 100;
    const savings = originalTotal - discountedTotal;
    const priceEl = miniDock.querySelector('.mini-bundle-price');
    const savingsEl = miniDock.querySelector('.mini-bundle-savings');
    if (priceEl) priceEl.textContent = `$${discountedTotal.toFixed(2)}`;
    if (savingsEl) savingsEl.textContent = `You saved $${savings.toFixed(2)}`;
  }

  // --- Mini Dock Show/Hide Logic ---
  var miniPicks = miniDock ? miniDock.querySelector('.mini-bundle-picks') : null;
  var miniCount = miniDock ? miniDock.querySelector('.mini-bundle-count') : null;
  function updateMiniDock() {
    if (!miniDock || !bundleSection) return;
    if (window.innerWidth > 767) {
      miniDock.style.display = 'none';
      return;
    }
    var rect = bundleSection.getBoundingClientRect();
    var isTopOutOfView = rect.top < 0;
    if (isTopOutOfView) {
      miniDock.style.display = 'flex';
    } else {
      miniDock.style.display = 'none';
    }
    // Update mini dock content
    if (miniPicks) {
      miniPicks.innerHTML = '';
      bundle.forEach(item => {
        miniPicks.innerHTML += `<img src="${item.image}" alt="${item.title}" loading="lazy" decoding="async">`;
      });
    }
    if (miniCount) {
      miniCount.textContent = bundle.length;
    }
    // Update price and savings
    const paidItems = bundle.filter((item, idx) => !(idx === 3 && item && item.price === 0));
    const originalTotal = paidItems.reduce((sum, item) => sum + (item.price || 0), 0);
    const discountedTotal = Math.round(originalTotal * 0.75 * 100) / 100;
    const savings = originalTotal - discountedTotal;
    const priceEl = miniDock.querySelector('.mini-bundle-price');
    const savingsEl = miniDock.querySelector('.mini-bundle-savings');
    if (priceEl) priceEl.textContent = `$${discountedTotal.toFixed(2)}`;
    if (savingsEl) savingsEl.textContent = `You saved $${savings.toFixed(2)}`;
  }

  // Initial UI
  updateStepUI();

  // --- Mini Dock Show/Hide Logic ---
  var miniDock = document.getElementById('mini-bundle-dock');
  var bundleSection = document.querySelector('.bundle-section');
  function updateMiniDock() {
    if (!miniDock || !bundleSection) return;
    if (window.innerWidth > 767) {
      miniDock.style.display = 'none';
      return;
    }
    var rect = bundleSection.getBoundingClientRect();
    var isTopOutOfView = rect.top < 0;
    if (isTopOutOfView) {
      miniDock.style.display = 'flex';
    } else {
      miniDock.style.display = 'none';
    }
    // Update mini dock content
    if (miniPicks) {
      miniPicks.innerHTML = '';
      bundle.forEach(item => {
        miniPicks.innerHTML += `<img src="${item.image}" alt="${item.title}" loading="lazy" decoding="async">`;
      });
    }
    if (miniCount) {
      miniCount.textContent = bundle.length;
    }
    // Update price and savings
    const paidItems = bundle.filter((item, idx) => !(idx === 3 && item && item.price === 0));
    const originalTotal = paidItems.reduce((sum, item) => sum + (item.price || 0), 0);
    const discountedTotal = Math.round(originalTotal * 0.75 * 100) / 100;
    const savings = originalTotal - discountedTotal;
    const priceEl = miniDock.querySelector('.mini-bundle-price');
    const savingsEl = miniDock.querySelector('.mini-bundle-savings');
    if (priceEl) priceEl.textContent = `$${discountedTotal.toFixed(2)}`;
    if (savingsEl) savingsEl.textContent = `You saved $${savings.toFixed(2)}`;
  }

  // Initial UI
  updateStepUI();

  // Make Review Bundle button scroll to Add Bundle to Cart button
  var miniReviewBtn = miniDock ? miniDock.querySelector('.mini-bundle-review-btn') : null;
  if (miniReviewBtn && addBundleToCartBtn) {
    miniReviewBtn.addEventListener('click', function() {
      addBundleToCartBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-product-color-capsule"] && !Shopify.designMode) return;
  try {
    
    
  document.addEventListener('DOMContentLoaded', function () {

    //desktop 
    document.querySelectorAll('.color-capsule-tabs__desktop').forEach(function (tabsWrapper) {
      const tabs = tabsWrapper.querySelectorAll('[data-tab]');
      const panels = tabsWrapper.querySelectorAll('[data-panel]');

      if (!tabs.length || !panels.length) return;

      function activateTab(index) {
        tabs.forEach((tab, i) => {
          const isActive = i === index;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel, i) => {
          panel.classList.toggle('is-active', i === index);
        });
      }

      // FORCE first tab active on page load
      activateTab(0);

      // Click handling
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', function () {
          activateTab(index);
        });
      });
    });

    //mobile 
    document.querySelectorAll('[data-capsule-acc]').forEach(function(root){
      const items = root.querySelectorAll('[data-acc-item]');
      const btns  = root.querySelectorAll('[data-acc-btn]');

      if(!items.length || !btns.length) return;

      function openIndex(i){
        items.forEach((item, idx) => item.classList.toggle('is-open', idx === i));
        btns.forEach((btn, idx) => {
          const isOpen = idx === i;
          btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          const icon = btn.querySelector('.capsule-acc__icon');
          if(icon) {
            if(isOpen) {
              icon.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 24 24"><path d="M6 12h12" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
            } else {
              icon.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 24 24"><path d="M6 12h6m6 0h-6m0 0V6m0 6v6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
            }
          }
        });
      }

      // first open on load
      openIndex(0);

      btns.forEach((btn, idx) => {
        btn.addEventListener('click', function(){
          const currentlyOpen = items[idx].classList.contains('is-open');
          if(currentlyOpen){
            // Close it
            items[idx].classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
            const icon = btn.querySelector('.capsule-acc__icon');
            if(icon) {
              icon.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 24 24"><path d="M6 12h6m6 0h-6m0 0V6m0 6v6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
            }
          } else {
            openIndex(idx);
          }
        });
      });
    });

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient-glossary"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

    document.querySelectorAll('.summary__link').forEach(link => {
        link.addEventListener('click', function(event) {
            if (this.hash !== "") {
                event.preventDefault(); // Prevent the default behavior
                const hash = this.hash; // Get the hash value

                // Smoothly scroll to the target section
                const target = document.querySelector(hash);
                target.scrollIntoView({
                    behavior: 'smooth' // Enables smooth scrolling
                });

                // Update the URL hash without jumping
                history.pushState(null, '', hash);
            }
        });
    });
    
    // AddToCart button product card
    function handleClick(e){
      var btn = e.target.closest('.product-buy-buttons--primary');
      if (!btn) return;

      // if it's a smart payment secondary button, don't intercept
      if (btn.getAttribute('data-item') === 'secondary-button') return;

      var root = btn.closest('product-buy-buttons-root') || btn.closest('.product-buy-buttons--root');
      if (!root) return;

      e.preventDefault();

      if (btn.disabled) return;

      var select = root.querySelector('.product-buy-buttons--select');
      var variantId = select ? select.value : null;
      if (!variantId) return;

      //btn.setAttribute('aria-busy','true');
      //btn.disabled = true;

      var textEl = btn.querySelector('.product-buy-buttons--cta-text');
      textEl.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(response){
        if (!response.ok) throw response;
        return response.json();
      })
      .then(function(data){
        try { window.dispatchEvent(new CustomEvent('cart:ajaxAdd', { detail: data })); } catch(e){}

        var textEl = btn.querySelector('.product-buy-buttons--cta-text');
        var originalText = btn.getAttribute('data-text') || (textEl ? textEl.textContent : 'Added');
        if (textEl) textEl.textContent = 'Added';
        setTimeout(function(){ if (textEl) textEl.textContent = originalText; }, 1400);
      })
      .catch(function(err){
        if (err && typeof err.json === 'function') {
          err.json().then(function(j){ console.error('Add to cart error', j); });
        } else {
          console.error(err);
        }
      })
      .finally(function(){
        //btn.setAttribute('aria-busy','false');
        //btn.disabled = false;
      });
    }

    document.addEventListener('click', handleClick, { capture: false });

  });
  

  } catch(e) { console.error(e); }
})();
})();
